var _title, _desc, _defs, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    id: "svg2"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title4"
  }, "4D36904D-75A6-46DF-8A5D-43A5A9A4FA00")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc6"
  }, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99897282,10.4225636 C7.78531992,10.4225636 7.57166702,10.3354589 7.42375348,10.1817932 L3.44652258,6.20291887 C3.11782581,5.88161778 3.11782581,5.36145516 3.44652258,5.04097581 C3.76700193,4.71967473 4.28469934,4.71967473 4.60517869,5.04097581 L7.99897282,8.43805685 L11.4009844,5.04097581 C11.7214637,4.71967473 12.2391611,4.71967473 12.5596405,5.04097581 C12.8801198,5.36145516 12.8801198,5.88161778 12.5596405,6.20291887 L8.58240959,10.1817932 C8.42627862,10.3354589 8.22084314,10.4225636 7.99897282,10.4225636",
    id: "path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fitness-Style",
    transform: "matrix(1,0,0,-1,0,7.2225636)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fitness-Style---Dashboard---Account---Reimbursement-History",
    transform: "translate(-389,-615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(190,149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0,339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(29,89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Action/ic_action_Arrow-Input",
    transform: "translate(167,34)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    id: "use19",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("use", {
    id: "ic_action_Arrow-Input",
    xlinkHref: "#path-1",
    style: {
      fill: "#9b9b9b",
      fillRule: "nonzero"
    },
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })))))))));
}
export default __webpack_public_path__ + "static/media/ic-action-arrow-up.9e956a70.svg";
export { SvgIcActionArrowUp as ReactComponent };